import { Dialog } from "@base-ui/react/dialog";
import { Lightbulb } from "lucide-react";
import { pl } from "../i18n/pl";
import type { Problem } from "../types";
import styles from "./HintDialog.module.css";

type HintDialogProps = {
  open: boolean;
  problem: Problem;
  result: number;
  onOpenChange: (open: boolean) => void;
  onRetry: () => void;
};

export function HintDialog({ open, problem, result, onOpenChange, onRetry }: HintDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className={styles.backdrop} />
        <Dialog.Popup className={styles.popup}>
          <div className={styles.icon}>
            <Lightbulb size={25} />
          </div>
          <Dialog.Title className={styles.title}>{pl.hint.title}</Dialog.Title>
          <Dialog.Description className={styles.description}>
            {pl.hint.equation(problem, result)} {pl.hint.rule(problem)}
          </Dialog.Description>
          <Dialog.Close className={styles.retryButton} onClick={onRetry}>
            {pl.hint.retry}
          </Dialog.Close>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
